import { useState } from 'react';

import { useNewStrategyContext } from './NewStrategyContext';

import { Icon } from '../UI';
import { Category } from './Category';
import { ProfitLoss } from '../ProfitLoss';
import { Title } from './Title';

import { StrategyDuplication as Props } from './types';
import { IStrategyAsset } from '../../types/model';

import { getSymbol } from '../../helpers/functions';
import { AccordionButton } from './AccordionButton';

export const StrategyDuplication = ({
  isNewStrategy,
  strategy: { assets, categories, currency, name, percent, totalValue },
}: Props) => {
  const { newStrategy, dispatch } = useNewStrategyContext();

  const [showCategories, setShowCategories] = useState(true);

  const newStrategyAssets = newStrategy.assets;
  const newAssetsIds = newStrategyAssets.map(({ id }) => id);
  const svgName = isNewStrategy ? 'trash' : 'plus';
  const symbol = getSymbol(currency);
  const selectedAllAssets =
    !isNewStrategy && assets.every(({ id }) => newAssetsIds.includes(id));

  const handleAssets = (selectedAssets: IStrategyAsset[]) => {
    let newAssets = [...newStrategyAssets];

    selectedAssets.forEach((asset) => {
      isNewStrategy
        ? // remove asset
          (newAssets = newAssets.filter(({ id }) => id !== asset.id))
        : // add assets only if they don't already exist
          !newAssetsIds.includes(asset.id) && newAssets.push(asset);
    });

    dispatch({ newStrategy: { ...newStrategy, assets: newAssets } });
  };

  const handleDropdown = () => setShowCategories(!showCategories);

  return (
    <>
      {!isNewStrategy && (
        <div
          className={`
          grid
          grid-cols-6
          items-center
          pl-5
          min-h-16
          border-b
          border-grey-${showCategories ? 30 : 50}
          dark:border-grey-${showCategories ? 70 : 80}
          bg-grey-30
          dark:bg-grey-70
        `}
        >
          <Title
            className="col-span-4"
            title={name}
            prefix={
              <AccordionButton
                isOpen={showCategories}
                handleDropdown={handleDropdown}
              />
            }
          />

          {/* tot value */}
          <ProfitLoss
            percentage={percent}
            symbol={symbol!}
            value={totalValue}
          />

          {/* percentage invested */}
          <div className="flex items-center justify-between">
            <span>100 %</span>
            <Icon
              className={`
              mr-5
              ${selectedAllAssets ? 'cursor-not-allowed' : 'cursor-pointer'}
            `}
              onClick={() => handleAssets(assets)}
              svgName={svgName}
              color={selectedAllAssets ? 'grey-50' : undefined}
            />
          </div>
        </div>
      )}
      {showCategories &&
        categories.map((category) => (
          <Category
            key={category.title}
            category={category}
            currency={currency}
            isNewStrategy={isNewStrategy}
            totalValueStrategy={totalValue}
          />
        ))}
    </>
  );
};
